module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch04_hd",
      "role": "doc-chapter"
    }
  }, [_c('h2', {
    staticClass: "h2chap",
    attrs: {
      "id": "ch04_hd"
    }
  }, [_vm._v("CHAPTER 4: CONTROL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "f1"
  }, [_vm._v("he turnfin")]), _vm._v(" perched on Eva’s shoulder gobbled down the last few nutriment pellets from the palm of her hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You better stop feeding your breakfast to these birds.” Hailey smirked. “I don’t have a whole lot of pellets, and I don’t know how many we’ll find back at the ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva kept her focus on the bird. “I’ll be all right.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What do you want with a bird anyway?” Hailey leaned over to get a closer look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m asking for a favor.” Eva stroked the turnfin’s sleek plumage. It gave a low cluck and then took flight. Eva and Hailey shielded their eyes from the sun to watch. The turnfin flapped its triple pair of wings to join the flock of other birds circling high "), _c('span', {
    attrs: {
      "aria-label": "page 34",
      "id": "page_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("above the tree. After several aerobatic loops the lone turnfin broke away from the others. It began winging west toward the Wandering Forest.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s going to check on Rovender,” Eva said, keeping an eye on the bird as it soared over the treetops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s amazing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva turned to him. “What?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How you can now understand animals and trees and stuff.” A smile curled at the corner of Hailey’s mouth. “You "), _c('i', [_vm._v("are")]), _vm._v(" better than an Omnipod.” He kept his gaze on the diminishing silhouette of the turnfin. “Do you hear every bird and animal all the time?” He leaned close to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not if I don’t want to.” Eva pulled out the strands of hair that had blown into the corners of her mouth. She separated several more pieces and began to braid them together. “It’s like everything alive gives off a kind of frequency, a pulse, that I can feel.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I get it. Like an electric current,” Hailey said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva unzipped a pocket in her coveralls and pulled out a handful of dried seedpods that she’d collected from the forest. She began braiding these pods into her hair. “If I shut off everything—you know, like what I’m actually seeing and "), _c('span', {
    attrs: {
      "aria-label": "page 35",
      "id": "page_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("hearing—then I can link to that frequency and understand it. It was hard at first. I couldn’t really control it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But now you can?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Now I can.” Eva remembered her attempts to communicate with the deadly sand-snipers… and how badly that could have ended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know what you mean. It’s sort of like when I’m flying.” Hailey gestured to his ears. “If I turn my music up really loud, I just feel more attuned to the controls of the ship. I’m not as distracted by my own thoughts, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva smiled. She doubted that was anything like her abilities, but at least Hailey was trying… and was less annoying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey gazed up to the sky in a wistful way. “Boy, I do miss that ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry. She was a good ship.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In some ways I’m glad you rescued me in the dark of night. I couldn’t see how bad the damage was,” Hailey said. “But I guess I’ll be seeing it anyways.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The wandering tree creaked and came to a stop. Eva looked down and saw that they were at the edge of a shallow lake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey appeared alarmed. “What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 36",
      "id": "page_36",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Don’t worry. The tree just needs a water break.” Eva stood and stretched. She scanned the horizon and saw that they were surrounded by flat plain. "), _c('i', [_vm._v("There is no place to hide should we be discovered,")]), _vm._v(" she thought, and climbed down from her perch to the shore below.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey followed her. “So we just wait here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva sat on the ground and pulled off her sneakboots. She got up, walked to the shore, and dipped her toes into the water. It was shallow enough that the sun had warmed it, like a bath. She closed her eyes. Like the tree submerging its roots, she could feel her body rejuvenate from the water. She listened to the vibration—the energy—of the lake. Within it Eva could feel the movement of many fish and crustaceans. She remembered the gigantic aquatic plant that had nearly killed Rovender, but there was nothing like that present. On the far shore she sensed two tall animals—possibly Cærulean munt-runners—drinking. Eva could barely make out their birdlike bipedal shapes. They appeared unaccompanied. She attempted communication with them but received no response. Something scuttled across Eva’s toes, breaking her link to the munt-runners. A sandy-patterned spiderfish, about the size of her hand, "), _c('span', {
    attrs: {
      "aria-label": "page 37",
      "id": "page_37",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("crawled on elongate fingerlike fins through the shallows.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello there,” Eva whispered to the fish. She knelt down slowly and steadily, like the movement of a wandering tree. The spiderfish remained in place. Eva dipped her fingers into the water and stroked its smooth sides. She could sense the animal’s thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("It moves. I grab. I eat. It moves. I grab. I eat.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva watched the fish dart after a crab. She waded after it. Like the fish, she felt pangs in her stomach. For the first time since she’d escaped from Lacus, Eva was hungry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey called from the shore. “Hey, what’re you doing?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Trying to get lunch.” She kept her focus on the fish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey produced several packets of nutriment pellets from his jacket pocket. “I’ve got you covered. What flavor do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t stand the taste of those pellets. They’re just chemicals.” Eva knelt back down in the water. “But I am starving.” She stood. In her hands she gripped the wriggling spiderfish. “Want some?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh, really?” Hailey popped a handful of pellets into his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 38",
      "id": "page_38",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“Yes. Really.” Eva brought the fish to shore and set it down at his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey grimaced at the peculiar spiderfish gasping for air. “So is it going to be tough for you to eat something you can now talk to?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva wiped her hands on the knees of her coveralls. “To quote Rovender, ‘Its energy and spirit will replenish mine. I respect this, and I shall enjoy my meal,’ ” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Better enjoy your meal before it crawls away.” Hailey pointed. The spiderfish was scurrying back to the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva chased the fish down and retrieved it. “Do you have some sort of cutting device?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve got a small laser-cutter used for splitting electrical wires.” Hailey pulled the tool from his pocket. “It even has a penlight in the handle.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That works,” she said, and took the laser-cutter.")]), _vm._v(" "), _c('hr', {
    staticClass: "secbreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I’ve eaten some strange stuff in the outlands where we live,” Hailey said, “but I never thought I’d eat raw spiderfish.” They were seated in a low perch on the wandering tree, shaded from the warm afternoon sun. “I haven’t been this full in a long time… though, it is weird to think that we just ate a dead animal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 39",
      "id": "page_39",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“My sister felt the same way,” Eva said. She watched the lake disappear on the horizon as the tree shuffled onward. She had hoped to see the pair of munt-runners, but they had moved on.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eva Eight?” Hailey yanked off his sneakboots and kicked his feet up onto the edge of the large hardened leaves. “You haven’t mentioned her since we’ve been out here. Did she not make it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She… decided to stay behind.” Eva looked west toward the green line of the forest. At least her sister was deep in the Heart of the Wandering Forest, safe from Cadmus’s warbots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh.” Hailey seemed puzzled by Eva’s vague answer. “So she’s okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think she’s found a good place to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey folded his arms behind his head and leaned back against the trunk of the tree. “I know she was real worried about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva looked over at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She told me when we were escaping in the "), _c('i', [_vm._v("Bijou")]), _vm._v(".” Hailey slid his flight cap over his eyes, ready to nap. “She said you were all she cared about in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I… I care about her too.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hailey chuckled from under his cap. “You don’t sound too convinced.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 40",
      "id": "page_40",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“She wanted to move back into our old home and live as if the world hadn’t changed, and that just wasn’t going to happen,” Eva said in a flat tone.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t blame you,” said Hailey. “I was just asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eva scooted next to him. From around her neck she pulled out a locket—a small clear vial—that had been a gift from the Cærulean shaman, Soth. Inside was soil from Soth’s home planet and, even more special, an orchidlike bloom given to Eva from her sister after Eva Eight had been transformed into a human-tree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thinking back, the encounter seemed like the stuff of nightmares. But Eva knew it had happened. She blurted out, “Remember the Vitae Virus generator?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That device that rebooted the planet? You guys were talking about that on the ship.” Hailey kept the cap over his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, I knew where it was. Eight became crazy—obsessed—with finding it before Cadmus. She forced me, at gunpoint, to take her to the generator in the Heart of the forest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you did it?” Hailey lifted up the bill of his cap to look at Eva.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": "page 41",
      "id": "page_41",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“I did it.” Eva rubbed her hands over her sides, where she’d once had broken ribs.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, that is a little over the top. But I can see why she wanted it.” Hailey slouched back down and adjusted the cap back over his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? You’re siding with her!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t say that.” Hailey interlaced his fingers and rested his hands on his chest. “I just think your sister wanted to take control of something—anything—in her life. The truth is, Cadmus controlled both your lives since you were hatched from test tubes. But somehow you, Eva, were able to break away from that control.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truth was, everything in Eva’s life now seemed beyond her control—the invasion of Lacus and Solas, the animosity she’d received from the fleeing Halcyonus, her failure to warn Arius. It had caused Eva to feel helpless, frustrated, and angry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She kissed the locket and tucked it back into her coveralls. “I forgive you, Sister,” she whispered.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cb4b986","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781481403887/xhtml/ch04.vue
// module id = 111
// module chunks = 0